import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { useParams } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';

import PreviewImage from 'components/Modals/PreviewImage';
import DetailOrder from './DetailOrder';
import EditOrder from './EditOrder';
import { fetchOrderBookingZoneById } from 'features/orders/actions';
import { fetchCustomerInfo } from 'features/user/actions';
import { useDispatch, useSelector } from 'react-redux';
import { getPaymentMethods } from 'features/payment/actions';

const DetailOrderCarCharterComponent = () => {
  const dispatch = useDispatch();

  const { data: orderData, status } = useSelector((state) => state.detailOrder);

  const [showImage, setShowImage] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');

  const { transactionKey } = useParams();
  const [searchParams] = useSearchParams();

  const isUpdating = searchParams.get('update');

  useEffect(() => {
    if (transactionKey) {
      dispatch(fetchOrderBookingZoneById(transactionKey));
      dispatch(fetchCustomerInfo(searchParams.get('customerId')));
      dispatch(getPaymentMethods());
    }
  }, [transactionKey]);

  const getFileName = (path = '') => {
    if (typeof path === 'string') {
      return path?.split('/')?.pop();
    } else {
      return '-';
    }
  };

  const imagePreviewHandler = (image) => {
    setShowImage(true);
    setSelectedImage(image);
  };

  return (
    <>
      {isUpdating ? (
        <EditOrder
          transactionKey={transactionKey}
          orderData={orderData}
          getFileName={getFileName}
          imagePreviewHandler={imagePreviewHandler}
          status={status}
        />
      ) : (
        <DetailOrder
          getFileName={getFileName}
          imagePreviewHandler={imagePreviewHandler}
          orderData={orderData}
          transactionKey={transactionKey}
          status={status}
        />
      )}
      {showImage &&
        ReactDOM.createPortal(
          <PreviewImage image={selectedImage} setShow={() => setShowImage(false)} />,
          document.getElementById('modal'),
        )}
    </>
  );
};

export default DetailOrderCarCharterComponent;
